exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.order-row__status[data-v-6055af7c] {\n  padding: 4px 10px;\n}\n.order-row__status .stage[data-v-6055af7c] {\n    cursor: pointer;\n    width: 90px;\n}\n", "", {"version":3,"sources":["/Users/soslanbolotaev/project/brunch_system-crm/src/components/ordersDelivery/OrderRow.vue"],"names":[],"mappings":";AAuDA;EACI,kBAAiB;CAKpB;AAND;IAGM,gBAAe;IACf,YAAW;CACZ","file":"OrderRow.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.order-row__status {\n    padding: 4px 10px;\n    .stage {\n      cursor: pointer;\n      width: 90px;\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6055af7c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ordersDelivery/OrderRow.vue
// module id = Ur2I
// module chunks = 1